import React, { useState } from 'react';
import { connect } from "react-redux";
import { updateOrgProfile } from "../../../Redux/actions/organization";
import { uploadProfilePic} from "../../../Redux/actions/user";
import { addNotification } from "../../../Utilities/notifications"; 
import empty_profile from "../../../Assets/emptyimage.png";
import keycloak from '../../../keycloak';

function ProfileSettings(props){
    let { organization,user } = props;
    const [loading, setLoading] = useState(false)
    const [values, setValues] = useState({...organization});
    const [submitBtnFlag, setSubmitBtnFlag ] = useState(true)

    const handleInputChange = e => {
      const { name, value } = e.target;
      setValues({ ...values, [name]: value });
      setSubmitBtnFlag(false);
    };
 
    const uploadPic = async(e) =>{      
      let file = e.target.files[0] 
      if(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/jfif'){     
        let data = await uploadProfilePic(file)      
        setValues({ ...values, profile_pic: data.URL });      
      }
      setSubmitBtnFlag(false);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();        
        setLoading(true);        
        let status = await updateOrgProfile({...values},user);
        if(status === 200){
          addNotification({
            title: "Techforce.ai",
            message: "Profile has been Updated Successfully",
            type: "success"
          });
          keycloak.login();
        }
        setLoading(false);
    }

    return (
      <div className="profile-container">
        <div className="sub-head">
          <h2 className="heading">Profile Settings</h2>
        </div>
        <div className="form-container">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="emailAddress">Organization Name</label>
              <input
                type="text"
                name="display_name"
                value={values.display_name}
                disabled
                className="form-control"
                id="emailAddress"
                aria-describedby="emailHelp"
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email (public)</label>
              <input
                type="email"
                name="contact_email"
                onChange={handleInputChange}
                value={values.contact_email ? values.contact_email : ""}
                className="form-control"
                id="email"
                placeholder="Email"
              />
            </div>
            <div className="form-group">
              <label htmlFor="description">Description</label>
              <input
                type="text"
                name="description"
                onChange={handleInputChange}
                value={values.description ? values.description : ""}
                className="form-control"
                id="description"
              />
            </div>
            <div className="form-group">
              <label htmlFor="url">Url</label>
              <input
                type="text"
                name="url"
                onChange={handleInputChange}
                value={values.url ? values.url : ""}
                className="form-control"
                id="url"
              />
            </div>
            <div className="form-group">
              <label htmlFor="location">Location</label>
              <input
                type="text"
                name="location"
                onChange={handleInputChange}
                value={values.location ? values.location : ""}
                className="form-control"
                id="location"
              />
            </div>
            <div className="form-group">
              <label htmlFor="billing_email">Billing Email (private)</label>
              <input
                type="text"
                name="billing_email"
                onChange={handleInputChange}
                value={values.billing_email ? values.billing_email : ""}
                className="form-control"
                id="billing_email"
              />
            </div>
            <div className="text-center">
              <button
                type="submit"
                disabled={submitBtnFlag}
                onClick={handleSubmit}
                className="btn mr-3"
              >
                {loading ? "loading .." : "Update Profile"}
              </button>
            </div>
          </form>
          <div className="rect-img text-center">
            <img
              src={values.profile_pic ? values.profile_pic : empty_profile}
              className="rounded mx-auto d-block"
              alt="..."
            />
            <div className="profile"><input type="file" name="profile_pic" accept="image/*" onChange={uploadPic}/></div>
            
          </div>
        </div>
      </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.user
})

export default connect(mapStateToProps, null)(ProfileSettings);